import * as _ from 'lodash';
import { FormEvent } from 'react'
import { Col, ControlLabel, Form, FormControl, FormGroup, Radio } from 'react-bootstrap'
import { IRecipientProfilePostTransplantData } from '@nkr/models/index'
import { IValidation } from './validation';

interface IProps {
    data: IRecipientProfilePostTransplantData,
    validation: IValidation,
    onChange: (e: FormEvent<FormControl & HTMLSelectElement & HTMLInputElement>) => void,
}

const PatientStatus = (props: IProps) => {
    if (props == null) {
        return <></>
    }

    return (
        <Form horizontal>
            <FormGroup>
                <Col xs={12} sm={12} lg={6} componentClass={ControlLabel}>
                    Patient is still alive?
                </Col>
                <Col xs={12} sm={12} lg={6}>
                    <div style={{ minHeight: 34 }}>
                        <Radio inline name='isAlive' value={1} checked={props.data.isAlive != null ? props.data.isAlive : false} onChange={props.onChange}>Yes</Radio>
                        <Radio inline name='isAlive' value={0} checked={props.data.isAlive != null ? !props.data.isAlive : false} onChange={props.onChange}>No</Radio>
                    </div>
                </Col>

            </FormGroup>

            {props.data.isAlive === false && (
                <>
                    <FormGroup validationState={props.validation.deathDate == false ? 'error' : null}>
                        <Col xs={12} sm={12} lg={6} componentClass={ControlLabel}>
                            Patient Death Date?
                        </Col>
                        <Col xs={12} sm={12} lg={6}>
                            <FormControl
                                name='deathDate'
                                value={props.data.deathDate}
                                onChange={props.onChange} />
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.validation.primaryCauseOfDeath == false ? 'error' : null}>
                        <Col xs={12} sm={12} lg={6} componentClass={ControlLabel}>
                            Primary Cause of Death?
                        </Col>
                        <Col xs={12} sm={12} lg={6}>
                            <FormControl
                                name='primaryCauseOfDeath'
                                value={props.data.primaryCauseOfDeath}
                                onChange={props.onChange} />
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col xs={12} sm={12} lg={6} componentClass={ControlLabel}>
                            Secondary Cause of Death?
                        </Col>
                        <Col xs={12} sm={12} lg={6}>
                            <FormControl
                                name='secondaryCauseOfDeath'
                                value={props.data.secondaryCauseOfDeath}
                                onChange={props.onChange} />
                        </Col>
                    </FormGroup>
                </>
            )}
        </Form>
    )
}

export default PatientStatus;